module.exports = __webpack_public_path__ + "static/img/discount.bcd7395.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/discount.jpg
// module id = BG/k
// module chunks = 6